import Image from 'next/legacy/image';

const AppFooter = () => {
	const currentYear = () => {
		return new Date().getFullYear();
	};

	return (
		<footer>
			<p className="text-sm">© {currentYear()} Fast and Clean</p>
			<div className="flex justify-center mt-4">
				<p>
					<a
						href="/files/regulamin-konkursu.pdf"
						target="_blank"
						rel="noreferrer"
						className="hover:underline text-sm"
					>
						Regulamin Konkursu
					</a>
				</p>
			</div>
			<ul className="social-icons">
				<li>
					<a
						href="https://www.facebook.com/ECO-Pralnia-Fast-Clean-109826467258955/"
						target="_blank"
						rel="noreferrer"
						title="Visit our fanpage"
					>
						<Image
							src="/assets/facebook-icon.svg"
							height="32"
							width="32"
							alt="Facebook icon"
						/>
					</a>
				</li>
				<li>
					<a
						href="https://www.instagram.com/ecopralniafastandclean/"
						rel="noreferrer"
						target="_blank"
						title="Visit our instagram page"
					>
						<Image
							src="/assets/instagram-icon.svg"
							height="32"
							width="32"
							alt="Instagram icon"
						/>
					</a>
				</li>
			</ul>
		</footer>
	);
};

export default AppFooter;
